import { request } from "../_helpers/Auth";

const namespace = "/api";

export const createRight = (payload) => {
    return request({
        url: namespace + "/right",
        method: "post",
        data: payload,
    });
};

export const getDefaultRights = () => {
    return request({
        url: namespace + "/rights/default",
        method: "get",
    });
};
export const getRight = (righ_id) => {
    return request({
        url: namespace + "/right/" + righ_id,
        method: "get",
    });
};

export const getRightsProfile = () => {
    return request({
        url: namespace + "/rights",
        method: "get",
    });
};

export const deleteRightAPI = (_id) => {
    return request({
        url: namespace + "/right/" + _id,
        method: "delete",
    });
};



export const modifyRight = (right_id, payload) => {
    return request({
        url: namespace + "/right/" + right_id,
        method: "put",
        data: payload,
    });
};

export const attachRightsProfile = (right_id, payload) => {
    return request({
        url: namespace + "/right/" + right_id + "/attach",
        method: "post",
        data: payload,
    });
};
